// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./node_modules/jquery/dist/jquery.js");
__webpack_require__("./node_modules/jquery-ui-dist/jquery-ui.js");
__webpack_require__("./node_modules/file-saver/dist/FileSaver.js");
__webpack_require__("./node_modules/bootstrap/dist/js/bootstrap.min.js");
__webpack_require__("./node_modules/popper.js/dist/umd/popper.min.js");
var __webpack_exports__ = __webpack_require__("./node_modules/@ng-bootstrap/ng-bootstrap/fesm2022/ng-bootstrap.mjs");
